<template>
    <v-dialog :value="show" max-width="900" @input="$emit('update:show', $event)">
        <v-card>
            <v-card-title class="d-flex align-center">
                <v-icon left color="primary">mdi-vector-link</v-icon>
                Detalhes da junção
                <v-spacer />
                <v-btn icon small @click="$emit('update:show', false)">
                    <v-icon small>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-subtitle>
                <strong>{{ discipline ? discipline.name : '' }}</strong>
            </v-card-subtitle>
            <v-card-text>
                <div v-if="loading" class="text-center py-4">
                    <v-progress-circular indeterminate color="primary" />
                </div>
                <v-alert
                    v-else-if="!joins.length"
                    type="info"
                    text
                    border="left"
                    dense
                >
                    Nenhuma junção encontrada para esta disciplina na trilha.
                </v-alert>
                <div v-else>
                    <div
                        v-for="join in joins"
                        :key="join.join_id"
                        class="join-block mb-3"
                    >
                        <div class="join-header d-flex align-center">
                            <v-icon small left color="primary">mdi-vector-link</v-icon>
                            <strong>Junção #{{ join.join_id }}</strong>
                            <v-chip x-small outlined class="ml-2">
                                {{ join.grids.length }} grade(s)
                            </v-chip>
                        </div>
                        <v-simple-table dense class="mt-2 join-table">
                            <thead>
                                <tr>
                                    <th>Turma</th>
                                    <th>Disciplina</th>
                                    <th>Período</th>
                                    <th>Grade</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="g in join.grids"
                                    :key="g.grid_id"
                                    :class="{ 'is-main': g.is_main }"
                                >
                                    <td>
                                        <div>{{ g.group ? g.group.name : '—' }}</div>
                                        <small v-if="g.group && g.group.code" class="grey--text">
                                            {{ g.group.code }}
                                        </small>
                                    </td>
                                    <td>
                                        <div>{{ g.discipline ? g.discipline.name : '—' }}</div>
                                        <small v-if="g.discipline && g.discipline.code" class="grey--text">
                                            [{{ g.discipline.code }}]
                                        </small>
                                    </td>
                                    <td>
                                        {{ g.work_time ? g.work_time.name : '—' }}
                                    </td>
                                    <td>
                                        <div class="d-flex align-center" style="gap: 4px">
                                            <v-chip x-small label outlined>
                                                {{ g.grid_code || g.grid_id }}
                                            </v-chip>
                                            <v-tooltip v-if="g.is_main" bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon x-small color="warning" v-bind="attrs" v-on="on">
                                                        mdi-star
                                                    </v-icon>
                                                </template>
                                                <span>Grade principal da junção</span>
                                            </v-tooltip>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn text @click="$emit('update:show', false)">Fechar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { getCurrentInstance, ref, watch } from 'vue'

export default {
    name: 'JoinInfoDialog',
    props: {
        show:       { type: Boolean, default: false },
        groupId:    { type: [Number, String], default: null },
        discipline: { type: Object, default: null },
    },
    emits: ['update:show'],
    setup(props) {
        const { proxy } = getCurrentInstance()
        const loading = ref(false)
        const joins = ref([])

        const fetchJoins = async () => {
            if (!props.show || !props.groupId || !props.discipline) return
            loading.value = true
            try {
                const res = await proxy.$store.dispatch('domainLearningPath/ActionGetJoinInfo', {
                    id: props.groupId,
                    disciplineId: props.discipline.id,
                })
                joins.value = (res && res.joins) || []
            } finally {
                loading.value = false
            }
        }

        watch(() => props.show, (v) => { if (v) fetchJoins() })

        return { loading, joins }
    },
}
</script>

<style scoped>
.join-block {
    background: #FAFAFA;
    border-radius: 6px;
    padding: 10px 12px;
}
.join-header {
    font-size: 13px;
}
.join-table tr.is-main td {
    background: rgba(245, 124, 0, 0.06);
}
</style>
